const styles = () => ({

  whiteTypography: {
    color: '#FFFFFF',
  },
});

export default styles;
